import React from 'react';
import styled from 'styled-components';
import {tabletWidth} from '../mixins';

const StyledCard = styled.div`
  width: 264px;
  height: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
  border-radius: 20px;
  
  @media screen and (min-width: ${tabletWidth}) {
      width: 320px;
  }

`

const Card = ({children}) => (
    <StyledCard>
        {children}
    </StyledCard>
);

export default Card;